// v2/hooks/useAccountBalance.js
import { useCallback, useEffect, useState } from 'react';
import { apiGet } from '../utils/api';
import { mapBalance } from '../utils/mapAccount';

export default function useAccountBalance() {
  const [ham, setHam] = useState(null);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const yenile = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const veri = await apiGet('/account-balance/');
      const bilgi = (veri && veri.account_info) || null;
      setHam(bilgi);
      setBalance(mapBalance(bilgi));
    } catch (e) {
      setError(e.message || 'Bakiye alinamadi');
      setBalance(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { yenile(); }, [yenile]);

  return { balance, info: ham, raw: ham, loading, error, yenile };
}
